export default __webpack_public_path__ + "static/media/bitreel-logo-sans-text.1a499eba.png";